import { render, staticRenderFns } from "./CustomerCreateDialog.vue?vue&type=template&id=76595086"
import script from "./CustomerCreateDialog.vue?vue&type=script&lang=js"
export * from "./CustomerCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports